import { render, staticRenderFns } from "./resources-dictionary-page.vue?vue&type=template&id=fab395f2&scoped=true"
import script from "./resources-dictionary-page.vue?vue&type=script&lang=js"
export * from "./resources-dictionary-page.vue?vue&type=script&lang=js"
import style0 from "./resources-dictionary-page.vue?vue&type=style&index=0&id=fab395f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab395f2",
  null
  
)

export default component.exports